import { useEffect, useState } from "react";

export function useRecaptcha(sitekey?: string) {
  const innerSiteKey = sitekey || import.meta.env.VITE_RECAPTCHA_KEY || "key_here";

  const [recaptcha, setRecaptcha] = useState("");

  useEffect(() => {
    let isUnmounted = false;
    let intervalId: ReturnType<typeof setInterval> | null = null;
    let attempts = 0;
    const maxAttempts = 50;

    const executeRecaptcha = async () => {
      if (typeof grecaptcha === "undefined" || !grecaptcha.enterprise) {
        return;
      }

      try {
        grecaptcha.enterprise.ready(async () => {
          const token = await grecaptcha.enterprise.execute(innerSiteKey, { action: "LOGIN" });

          if (!isUnmounted) {
            setRecaptcha(token);
          }
        });
      } catch {
        // Keeps the app stable if the script is blocked/unavailable.
      }
    };

    void executeRecaptcha();

    // The script is loaded with `defer`; retry briefly until the global API exists.
    intervalId = setInterval(() => {
      attempts += 1;

      if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise) {
        if (intervalId) {
          clearInterval(intervalId);
        }

        void executeRecaptcha();
        return;
      }

      if (attempts >= maxAttempts && intervalId) {
        clearInterval(intervalId);
      }
    }, 100);

    return () => {
      isUnmounted = true;

      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [innerSiteKey]);

  return recaptcha;
}
